import { render, staticRenderFns } from "./choosepeol.vue?vue&type=template&id=8e78473c&scoped=true"
import script from "./choosepeol.vue?vue&type=script&lang=js"
export * from "./choosepeol.vue?vue&type=script&lang=js"
import style0 from "./choosepeol.vue?vue&type=style&index=0&id=8e78473c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e78473c",
  null
  
)

export default component.exports